import { j as r } from "./kezios-design-system.esm172.js";
import { IconComponent as l } from "./kezios-design-system.esm4.js";
const c = (o) => (o.color, /* @__PURE__ */ r.jsxs(l, { viewBox: "0 0 16 16", stroke: "none", ...o, children: [
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: o.color ? "currentColor" : "#FEBA08",
      d: "M8.727 8.727H16V16H8.727z"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: o.color ? "currentColor" : "#05A6F0",
      d: "M0 8.727h7.273V16H0z"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: o.color ? "currentColor" : "#80BC06",
      d: "M8.727 0H16v7.273H8.727z"
    }
  ),
  /* @__PURE__ */ r.jsx(
    "path",
    {
      fill: o.color ? "currentColor" : "#F25325",
      d: "M0 0h7.273v7.273H0z"
    }
  )
] }));
export {
  c as IconWindows
};
